<template>
	<card class="ReRestrictions restrictions-table col-12">
		<div> 
			<el-table :data="masRestrictionList" :highlight-current-row="false"  style="width: 100%;" class="el-table--scrollable-x">
				<el-table-column
					sortable
					width="80"
					label="ИД"
					property="id"
				></el-table-column>
				<el-table-column
					sortable
					min-width="150"
					label="Имя"
					property="name"
				></el-table-column>
				<el-table-column
					min-width="200"
					label="Описание"
					property="descr"
				></el-table-column>
				<el-table-column
					width="170"
					label="Действие"
					align="right"                    	
				>
					<template v-slot="scope">						
						<ReActionBtns :masActions="masActions[scope.$index]"/>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</card>

</template>

<script>
// import { TabPane, Tabs, BaseSwitch } from 'src/components';
import { Table, TableColumn } from 'element-ui';
import ReActionBtns from 'src/our_components/ReActionBtns.vue';

export default {
	name: 'ReRestrictions',
	components: {
		// TabPane, 
		// Tabs,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		// BaseSwitch,
		ReActionBtns,
	},
	props: {
		counter: String,
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		}, 		
		masRestrictionList: {
			type: Array,
            default: function() {
				return [];
			}
		},             
		masActions: {
			type: Array,
            default: function() {
				return [];
			}
		},             
		objAddRestr: {
			type: Object,
            default: function() {
				return {};
			}
		},   
		    
	   
	},
	data () {
		return {
		}
	},
	computed: {

	},
	methods: {

	},
	mounted() {        
		
	}
}
</script>
<style scoped>

@media (max-width: 768px) {	
	.ReRestrictions >>> .el-table__body-wrapper {
		overflow-x: scroll;

	}	
}
</style>
